<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <svg-icon src="./assets/images/icons/close.svg"></svg-icon>
    </button>
</div>
<div class="modal-body text-center">
    <svg-icon src="./assets/images/icons/checked_gradient.svg" [svgStyle]="{'width.px':56}"
        class="d-block mb-3 mb-md-4"></svg-icon>
    <h4 class="font-weight-semibold mb-1 mb-md-2">Request Successful</h4>
    <p class="mb-2 mb-md-3 mb-lg-4 mb-xl-5">Your Work Entry Permit Request has been successfully submitted to
        CLA/Security User</p>
    <p class="font-weight-semibold mb-1 mb-md-2">Please Note your Work Entry Permit Reference No.</p>
    <p class="font-weight-semibold h3 text-primary mb-0">30356894</p>
</div>